<template>
  <div v-if="visible" class="banner_height">
    <div id="searchBar" :class="searchBarFixed == true ? 'ondown_banner' :'down_banner'">
      <div v-if="isStatus!=1" class="preview_bar">
        <a class="down_close" @click="goClose" />
        <div style="height: 4.48rem; line-height: 4.48rem;text-align: center; font-size: 1.04rem; color: #C99700">
          此为临时链接，仅用于预览，将在短期内失效。</div>
      </div>
      <template v-else>
        <div class="left_close">
          <a class="down_close" @click="goClose" />
          <img src="/webAssets/images/img/newLogo.png" alt="" class="down_himg">
        </div>
        <a class="download" @click="goDown">{{ $t('topHeader.buttonText') }}</a>
        <GCDOWN :down-show="DownShow" @showDwon="getshowDonw" />
        <GCGUIDE :down-show="weiXin" :img-type="$t('topHeader.shareImg')" @showDwon="getWechat" />
      </template>
    </div>
  </div>
</template>
<script>
import utils from '@/utils/utils'
import GCDOWN from '@/components/gc-down'
import GCGUIDE from '@/components/gc-guide'
import CallApp from '@/components/callapp.js'
export default {
  components: {
    GCDOWN,
    GCGUIDE
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    link: {
      type: String,
      default: ''
    },
    goDowning: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visible: this.isShow,
      weiXin: false,
      searchBarFixed: false,
      DownShow: false,
      parentData: {}
    }
  },
  computed: {
    isStatus() {
      return this.status
    }
  },
  created() {
    this.parentData = this.$route.query
  },
  mounted() {
    if (this.isShow) {
      window.addEventListener('scroll', this.handleScroll)
    }
    if (this.goDowning) {
      this.goDown()
    }
  },
  methods: {
    goDown() {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

      if (utils.is_weixn() && isAndroid) {
        this.weiXin = true
      } else if (isAndroid) {
        var protocol = 'cn.com.greatchef'
        var jumpurl = '?params={"des":"articlesview","skuid":"' + this.$route.query.id + '"}'
      } else {
        var protocol = 'cn.com.greatchef'
        var jumpurl = '/articlesview?id=' + this.$route.query.id
      }

      const option = {
        scheme: {
          protocol: protocol
        },
        universal: {
          host: 'oia.greatchef.com.cn',
          pathKey: ''
        },
        appstore: 'https://itunes.apple.com/app/id700641749',
        yingyongbao: 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.greatchef',
        fallback: 'https://oia.greatchef.com.cn/',
        timeout: 2000
      }

      const lib = new CallApp(option)
      lib.open({
        path: jumpurl
      })
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const offsetTop = document.querySelector('#searchBar') ? document.querySelector('#searchBar').offsetTop : 0
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
    goClose() {
      this.visible = false
    },
    getshowDonw(val) {
      this.DownShow = false
    },
    getWechat(val) {
      this.weiXin = false
    }
  }
}
</script>
<style lang="scss" scoped>
.preview_bar{
  display: flex;
  align-items: center;
}
</style>
